








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class Carousel extends Vue {
    @Prop({default: () => []})
    public images!: string[];
    public imagesPerPage = 5;
    public currentPage: number = 0;

    public previous() {
        if (this.currentPage === 0) {
            this.currentPage = this.lastPage;
        } else {
            this.currentPage--;
        }
    }

    public next() {
        if (this.currentPage === this.lastPage) {
            this.currentPage = 0;
        } else {
            this.currentPage++;
        }
    }
    public get currentImages() {
        const start = this.currentPage * this.imagesPerPage;
        return this.images.slice(start, start + this.imagesPerPage);
    }
    public get lastPage() {
        return Math.floor(this.images.length / this.imagesPerPage);
    }

    public calculatedStyle(image) {
        return `
            height:50px;
            min-width:50px;
            background-image:url('${image}');
            background-size:cover;
            background-position:center;
        `;
    }
}
